import React, { Component } from "react";
import { Button } from 'react-bootstrap';
import { variables } from "../../Variables.js";
import Alert from "../../components/Alert.jsx";
import MyPage from "../../MyPage.js";
import SubTabsInputs from "../../SubTabsInputs.js";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from "react-loader-spinner";
import InputsForecastsAnalysisVendor from './InputsForecastsAnalysisVendor.jsx';
import axiosService from '../../helpers/axios';

export default class InputsForecastsAnalysis extends Component {
  constructor(props) {
    super(props);
    this.state = {
        data: [],
        dataWithoutFilter:[],
        loading: true,
        currentYearIndex: 0,
        currentYear: null,
        id: 0,
        quantity_type : "",
        FiscalYearFilter : "",
        WarehouseNameFilter : "",
        sapCodeFilter : "",
        sapcode : "",
        warehousename : "",
        fyname : "",
        total : "",
        july : "",
        august: "",
        september : "",
        october: "",
        november : "",
        december : "",
        january : "",
        february : "",
        march : "",
        april : "",
        may : "",
        june: ""
    };
  }

  FilterFn() {
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    const sapCodeFilter = this.state.sapCodeFilter;

    var filteredData = this.state.dataWithoutFilter.filter(function (el) {
      return (
        el.warehousename
          .toString()
          .toLowerCase()
          .includes(WarehouseNameFilter.toString().trim().toLowerCase()) &&
        el.fyname
          .toString()
          .toLowerCase()
          .includes(FiscalYearFilter.toString().trim().toLowerCase()) &&
        el.sapcode
          .toString()
          .toLowerCase()
          .includes(sapCodeFilter.toString().trim().toLowerCase())
        // el.sapcode
        //   .toString()
        //   .toLowerCase()
        //   .includes(ProductIdFilter.toString().trim().toLowerCase())
      );
    });

    this.setState({ data: filteredData });
  }

  sortResult(prop, asc) {
    var sortedData = this.state.outboundWithoutFilter.sort(function (a, b) {
      if (asc) {
        return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
      } else {
        return b[prop] > a[prop] ? 1 : b[prop] < a[prop] ? -1 : 0;
      }
    });

    this.setState({ outbound: sortedData });
  }

  changeCountryNameFilter = (e) => {
    this.state.CountryNameFilter = e.target.value;
    this.FilterFn();
  };

  changeRegionNameFilter = (e) => {
    this.state.RegionNameFilter = e.target.value;
    this.FilterFn();
  };

  changeWarehouseNameFilter = (e) => {
    this.state.WarehouseNameFilter = e.target.value;
    this.FilterFn();
  };

  changeFiscalYearFilter = (e) => {
    this.state.FiscalYearFilter = e.target.value;
    this.FilterFn();
  };

  changeProductDescriptionFilter = (e) => {
    this.state.ProductDescriptionFilter = e.target.value;
    this.FilterFn();
  };

  changeForecastIdFilter = (e) => {
    this.state.ForecastIdFilter = e.target.value;
    this.FilterFn();
  };

  changeOutboundIdFilter = (e) => {
    this.state.OutboundIdFilter = e.target.value;
    this.FilterFn();
  };

  changeCurrentYearFilter = (e) => {
    this.state.CurrentYearFilter = e.target.value;
    this.FilterFn();
  };

  changeSapCodeFilter = (e) => {
    this.state.sapCodeFilter = e.target.value;
    this.FilterFn();
  };

  refreshList = () => {
    axiosService.get("/forecast_procurement/")
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({
          data: data,
          dataWithoutFilter: data,
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        this.setState({ loading: false });
      });
  };

  
  updateForecastProcurment = () => {
    axiosService.get('/forecast_procurement_update/')
    .then(result => {
      alert('Data updated');
    })
    .catch(error => {
      alert('Failed: ' + error.message);
    });
  };

  componentDidMount() {
    this.refreshList();
  }

  render() {
    const {
      id,
      data,
      modalTitle,
      outboundid,
      forecastid,
      countryname,
      warehousename,
      regionname,
      fyname,
      productdescription,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      loading,
      fiscalYears,
      currentYearIndex,
      currentYear,
    } = this.state;

    //const currentYear = fiscalYears[currentYearIndex];

    return (
      <div className="scrollable-container">
        <MyPage />
        <SubTabsInputs />
        <div
          style={{ 
            textAlign: "right",
            marginTop: "1.2em"
          }}
        >
          <Button variant="success"
          disabled={!isSuperAdmin()}
          style={{ height: "28px", fontSize: "12px" }}
          onClick={()=>{this.updateForecastProcurment()}}
          >
            Update
          </Button>
        </div>
        <div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
            Forecasts on Procurement / per WareHouse
        </div>
        <div className="table-container-forecast-analysis">
          <table className="table table-striped">
            <thead>
              <tr className="header-row-fixed">
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center">
                  <input
                      className="form-control m-2"
                      style={{
                        width: "70px",
                        height: "30px",
                        fontSize: "12px",
                      }}
                      onChange={this.changeWarehouseNameFilter}
                      placeholder="Filter"
                    />
                  </div>
                  Warehouse
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center">
                    <input
                      className="form-control m-2"
                      style={{
                        width: "70px",
                        height: "30px",
                        fontSize: "12px",
                      }}
                      onChange={this.changeFiscalYearFilter}
                      placeholder="Filter"
                    />
                  </div>
                  Fiscal Year
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center">
                  <input
                      className="form-control m-2"
                      style={{
                        width: "70px",
                        height: "30px",
                        fontSize: "12px",
                      }}
                      onChange={this.changeSapCodeFilter}
                      placeholder="Filter"
                    />
                  </div>
                  Sap code
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  Type
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  Total
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  July
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  August
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  September
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  October
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  November
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  December
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  January
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  Februrary
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  March
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  April
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  May
                </th>
                <th style={{ fontSize: "12px", textAlign: "center" }}>
                  <div className="d-flex flex-row align-items-center justify-content-center"></div>
                  June
                </th>
              </tr>
            </thead>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40vh",
                  width: "150vh",
                }}
              >
                {/* Use react-loader-spinner here */}
                <Blocks
                  visible={true}
                  height="100"
                  width="100"
                  ariaLabel="blocks-loading"
                  wrapperStyle={{}}
                  wrapperClass="blocks-wrapper"
                />
                <div style={{ marginLeft: "10px" }}>Loading...</div>
              </div>
            ) : (
              <tbody>
                {data.map((dep) => (
                  <tr key={dep.id} className="row-hover">
                    <td className="table-text">{dep.warehousename}</td>
                    <td className="table-text">{dep.fyname ?? "N/A"}</td>
                    <td className="table-text">{dep.sapcode ?? "N/A"}</td>
                    <td className="table-text">{dep.quantity_type ?? "N/A"}</td>
                    <td className="table-text">{dep.total ?? "N/A"}</td>
                    <td className={"table-text " + (dep.july < 0 && 'negative-value')}>{dep.july ?? "N/A"}</td>
                    <td className={"table-text " + (dep.august < 0 && 'negative-value')}>{dep.august ?? "N/A"}</td>
                    <td className={"table-text " + (dep.september < 0 && 'negative-value')}>{dep.september ?? "N/A"}</td>
                    <td className={"table-text " + (dep.october < 0 && 'negative-value')}>{dep.october ?? "N/A"}</td>
                    <td className={"table-text " + (dep.november < 0 && 'negative-value')}>{dep.november ?? "N/A"}</td>
                    <td className={"table-text " + (dep.december < 0 && 'negative-value')}>{dep.december ?? "N/A"}</td>
                    <td className={"table-text " + (dep.january < 0 && 'negative-value')}>{dep.january ?? "N/A"}</td>
                    <td className={"table-text " + (dep.february < 0 && 'negative-value')}>{dep.february ?? "N/A"}</td>
                    <td className={"table-text " + (dep.march < 0 && 'negative-value')}>{dep.march ?? "N/A"}</td>
                    <td className={"table-text " + (dep.april < 0 && 'negative-value')}>{dep.april ?? "N/A"}</td>
                    <td className={"table-text " + (dep.may < 0 && 'negative-value')}>{dep.may ?? "N/A"}</td>
                    <td className={"table-text " + (dep.june < 0 && 'negative-value')}>{dep.june ?? "N/A"}</td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
        <InputsForecastsAnalysisVendor/>
      </div>
    );
  }
}
